export default {
  type: "coupon",
  data: {
    paddingTop: 10,
    paddingBottom: 10,
    align: "center",
    height: "100",
    type: "string",  // 默认值，可以是"string"或"qrcode"
    content: "Coupon Code",  // 默认内容
    width: "100",
    style: "solid",
    color: { r: 0, g: 0, b: 0, },
  },
  children: [],
};
